module.exports = __webpack_public_path__ + "media/customizations/colton/logo-6fbc97aac0ed0ce0bb14c337dc830f79.png";